const environment = process.env.CONFIG;
const exerciseCourseListApi = `${environment.env.internalProxyUrl}v2/user_experience/course/list`;
// 根据品类与章节id获取推荐公开课信息
const getExerciseCourseList = async function ({app, section_id, category_id, subject_id}) {
    try {
        const params = subject_id
            ? {
                subjectIds: [subject_id],
                pageSize: 3,
                type: 9
            }
            : {
                seoCategory: `${category_id},${section_id}`,
                pageSize: 3,
                type: 9
            };
        const options = {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                os: 'h5-pc',
                applicationCode: 'gaotu-pc'
            }
        };
        const {data = {}, code = '', msg = ''} = await app.axiosServer.$post(exerciseCourseListApi, params, options);

        if (code === 0) {
            return {
                courseStatus: 0,
                courseList: data.courseList || []
            };
        }
        return {
            courseStatus: code,
            courseMsg: msg
        };
    }
    catch (e) {
        return {
            courseStatus: -1,
            courseMsg: e.message || 'error'
        };
    }
};

export default getExerciseCourseList;
